import React, { Component } from 'react';
import cookick from 'cookick';
import { RouteComponentProps, Switch, Route, Redirect } from 'react-router-dom';
import Title from 'components/Title';
import withSSR, { SSRProps } from 'utils/withSSR';
import security from 'stores/security';
import ui from 'stores/ui';
import API from 'utils/API';
import http from 'utils/http';
import CommissionsUS from './CommissionsUS';
import CommissionsHK from './CommissionsHK';
import CommissionsUSMarsco from './CommissionsUS/Marsco';
import Interest from './Interest';
import Nav from './Nav';

import './style.scss';

class Pricing extends Component<RouteComponentProps & SSRProps<{ data: any }>> {
    readonly state = {
        isIBClearing: this.props.currentUser?.isIBClearing
    };

    // 校正
    async checkUserClearing() {
        // 如果有token，则确认下修正当前账户类型
        if (security.ACCESS_TOKEN) {
            try {
                const res = await http.get(API.OAUTH_USER.webUserStatus(), {
                    params: {
                        //  注：app内打开webview时，os传 app，此时接口得到的 currentCustomerId 为APP中正在使用的账户，【特殊约定】
                        os: ui.isTiger ? 'app' : 'web'
                    }
                });

                const customerId = res.data?.actualAccountInfo?.currentCustomerId;

                if (customerId) {
                    const { data: info } = await http.get(API.CUSTOMER.web.accountInfo(), {
                        params: { customer_id: customerId }
                    });

                    const isIBClearing = info.clearing !== 'marsco';

                    // 如果与本地记录不同，则更新
                    if (this.state.isIBClearing !== isIBClearing) {
                        this.setState({
                            isIBClearing
                        });

                        if (isIBClearing) {
                            cookick.setCookie('isIBClearing', '1', {
                                maxAge: 3600 * 24 * 7,
                                path: '/'
                            });
                        } else {
                            cookick.delCookie('isIBClearing');
                        }
                    }
                }
            } catch (e) {}
        }
    }

    componentDidMount() {
        ui.setPid('pricing');

        security.init().finally(() => {
            this.checkUserClearing();
        });
    }

    renderMarsco() {
        const parentPath = this.props.match.path;

        return (
            <div className="page-pricing-switch">
                <Switch>
                    <Route path={`${parentPath}/commissions-us`} component={CommissionsUSMarsco} />
                    <Redirect to={{ ...this.props.location, pathname: `${parentPath}/commissions-us` }} />
                </Switch>
            </div>
        );
    }

    renderIB() {
        const parentPath = this.props.match.path;

        return (
            <>
                <Nav />
                <div className="page-pricing-switch">
                    <Switch>
                        <Route path={`${parentPath}/commissions-us`} component={CommissionsUS} />
                        <Route path={`${parentPath}/commissions-hk`} component={CommissionsHK} />
                        <Route path={`${parentPath}/interest`} component={Interest} />
                        <Redirect to={{ ...this.props.location, pathname: `${parentPath}/commissions-us` }} />
                    </Switch>
                </div>
            </>
        );
    }

    render() {
        const { isIBClearing } = this.state;

        return (
            <div className="page-pricing site-main">
                <Title title="Pricing" />
                {isIBClearing ? this.renderIB() : this.renderMarsco()}
            </div>
        );
    }
}

export default withSSR(Pricing, () => {});
